<template>
	<div class="sign">
		<sign-canvas class="sign-canvas" ref="SignCanvas" :options="options" v-model="value" />
		<div class="flex align-center justify-center"
			style="display: flex;align-items: center;justify-content: center;margin-top: 20px;">
			<div class="flex align-center" style="display: flex;align-items: center;">
				<div class="" style="margin-right: 20px;">
					<el-button @click="clearSignImg">重新签字</el-button>
					
					<el-button @click="handleClose">取 消</el-button>
				</div>
				<el-button type="primary" @click="saveSignImg">确 定</el-button>
			</div>
		</div>
		<!-- 	<div class="btnList" ref="btnList">
			<van-button type="danger" v-throttle size="small" @click="clearSignImg">清空</van-button>
			<van-button type="primary" v-throttle size="small" class="ml30 mr30" @click="saveSignImg">保存</van-button>
			<van-button type="primary" v-throttle size="small" @click="back">返回</van-button>
		</div> -->

	</div>
</template>
<script>
	// import {
	// 	config
	// } from "@/config/global.config";
	import SignCanvas from "sign-canvas";
	// import cApi from "@/api/auth/cApi";
	import axios from "axios";
	import {
		getMeetingSign,
	} from '@/serve/sign';
	//接口引入
	// import { signShipmentsContract } from "../../api/userMG";
	export default {
		name: "signDialog",
		props: ['noticeDialogVisibleRow'],

		// {
		// 	// 组件传递的值
		// 	visible: {
		// 		type: Boolean,
		// 		default: false,
		// 	},
		// 	// 图片信息Base64
		// 	src: {
		// 		type: String,
		// 		default: null,
		// 	},

		// },
		components: {
			SignCanvas
		},
		data() {
			return {
				value: null,
				//配置
				options: {
					lastWriteSpeed: 1, //书写速度 [Number] 可选
					lastWriteWidth: 2, //下笔的宽度 [Number] 可选
					lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
					lineJoin: "round", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
					canvasWidth: "960", //canvas宽高 [Number] 可选
					canvasHeight: "540", //高度  [Number] 可选
					isShowBorder: false, //是否显示边框 [可选]
					bgColor: "#fcc", //背景色 [String] 可选
					borderWidth: 1, // 网格线宽度  [Number] 可选
					borderColor: "#ff787f", //网格颜色  [String] 可选
					writeWidth: 5, //基础轨迹宽度  [Number] 可选
					maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
					minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
					writeColor: "#101010", // 轨迹颜色  [String] 可选
					isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
					imgType: "png", //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
				},
			};
		},
		created() {},
		mounted() {
			// let windowHeight = document.documentElement.clientHeight;
			// let btnList = this.$refs.btnList.offsetHeight;
			// let windowWidth = document.documentElement.clientWidth;
			// this.options.canvasWidth = windowWidth;
			// this.options.canvasHeight = windowHeight - btnList;
			// console.log(this.$refs.SignCanvas.saveAsImg(),"this.$refs.SignCanvas.saveAsImg()")
		},
		methods: {
			handleClose() {
				this.clearSignImg();
				this.$emit("handleClose");
			},
			//清除画板
			clearSignImg() {
				this.$refs.SignCanvas.canvasClear();
			},
			// 保存图片
			saveSignImg() {
				console.log(this.value, "value");
				console.log("value", this.value);
				if (this.value == '' || this.value == null || this.value == undefined) {
					this.$message({
						message: '签名异常，请重新签字！',
						type: 'warning'
					});
				} else {
					const img = this.$refs.SignCanvas.saveAsImg();
					this.signShipmentsContractFun(img);
					this.handleClose();
					// this.$confirm('请先确认签名是否正确,一旦签名成功，无法撤销', '签名确认', {
					// 	confirmButtonText: '确定',
					// 	cancelButtonText: '取消',
					// 	type: 'warning'
					// }).then(() => {
					// 	const img = this.$refs.SignCanvas.saveAsImg();
					// 	this.signShipmentsContractFun(img);
					// }).catch(() => {
					// 	this.$message({
					// 		showClose: true,
					// 		message: '签名取消,请重新签名'
					// 	});
					// 	// this.$refs.SignCanvas.canvasClear();
					// });
				}
			},
			//下载图片/
			// downloadSignImg() {
			//   this.$refs.SignCanvas.downloadSignImg();
			// },
			back() {
				this.$router.back(-1);
			},
			base64ToBlob(base64) {
				const bytes = window.atob(base64.split(',')[1])
				const array = new Uint8Array(bytes.length)
				for (let i = 0; i < bytes.length; i++) {
					array[i] = bytes.charCodeAt(i)
				}
				return new Blob([array], {
					type: 'application/octet-stream'
				})
			},
			// 签名
			async signShipmentsContractFun(img) {
				let ii = this.base64ToBlob(img);
				let formData = new FormData();
				formData.append('file', ii);
				// let url = 'https://api.pochanyun.com/api/sys/fs/';
				// let url = 'https://live.pochanyun.net/api/sys/fs/';
				let url = '/api/sys/fs/';
				await axios.post(url, formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(response => {
					console.log('文件上传成功', response);
					console.log("noticeDialogVisibleRow", this.noticeDialogVisibleRow)
					getMeetingSign(this.noticeDialogVisibleRow.id, response.data.id).then((res) => {
						console.log("res", res)
						this.$emit("succeed", res.id);
					});
				}).catch(error => {
					// console.error('文件上传失败', error);
				});
				// signShipmentsContract(params)
				//   .then((res) => {
				//     console.log(res, "签名");
				//     if (res.code == 200) {
				//       this.$toast.success({
				//         message: "保存成功",
				//         onClose: () => {
				//           this.$router.back(-1);
				//         },
				//       });
				//     } else {
				//       this.$toast.fail(res.msg);
				//     }
				//   })
				//   .catch((error) => {});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.btnList {
		// position: fixed;
		// bottom: 0;
		// left: 0;
		width: 100%;
		padding: 30px 0;
		display: flex;
		justify-content: center;
	}

	.sign-canvas {
		display: block;
		margin: 0 auto;
		background: #F1F1F1 !important;
		border-radius: 8px;
		width: 100%;
		height: 100%;

	}
</style>